import React
, {useEffect} from "react";
import Grid from "@material-ui/core/Grid";

import {
  Button,
  Checkbox,
  CircularProgress,
  Container,
  Divider,
  FormControlLabel,
  FormGroup,
  IconButton,
  Paper,
  Tooltip,
  Typography,
} from "@material-ui/core";
import { useStyles } from "./datenplausibilitaetStyles";
import { globalStyles } from "../../assets/globalStyles"; 
import { DatenplausibilitaetGrid } from "./grid";
import { ArrowForward, FilterList } from "@material-ui/icons";
import MessstellenFilter from "../../features/filter/messstellen";
import { DatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import { de } from "date-fns/locale";
import { selectDate } from "../../features/konfiguration/konfigurationSlice";
import { addTimezoneOffset, subtractTimezoneOffset } from '../../utils/utils';
import { useAppSelector, useAppDispatch } from '../../app/hooks';
import { getMesswertGeflaggt, selectListLoading, selectGeflaggteMesswerteListe, selectFilterStatus, selectFilterMonat,addStatus, removeStatus, setFilterMonat, setFilterMonatEnde, selectFilterMonatEnde, selectFirstLoad } from "./datenplausibilitaetSlice";
import { useMsal } from "@azure/msal-react";
import {
  getMessstellen,
  selectMessstelleWertTemp,
  setMessstelleWert, 
} from "../../features/filter/messstellenFilterSlice";
import { endOfMonth, startOfMonth } from "date-fns";



export const Datenplausibilitaet: React.FC = () => {
  const { instance } = useMsal();
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(getMessstellen());
  }, [instance]);
  

  const classes = {
    ...useStyles(),
    ...globalStyles(),
  };
  const { datePicker } = useStyles();

  const [filter, openFilter] = React.useState(true);

  const isUTC = useAppSelector(selectDate);
  const datenplausibilitaetList = useAppSelector(selectGeflaggteMesswerteListe);
  const loadingGrid = useAppSelector(selectListLoading);
  const filterStatus = useAppSelector(selectFilterStatus);
  const filterMonat = useAppSelector(selectFilterMonat);
  const filterMonatEnde = useAppSelector(selectFilterMonatEnde);
  const messstelleWert = useAppSelector(selectMessstelleWertTemp);
  const firstLoad = useAppSelector(selectFirstLoad);

  return (
    <React.Fragment>
      <Container maxWidth={false} style={{ marginTop: "10px" }}>
        <Grid container md={12} spacing={2} style={{ marginBottom: "10px" }}>
          <Grid item md={3} />
          <Grid item md={6}>
            <Typography color="primary" variant="h5">
              Datenplausibilität
            </Typography>
          </Grid>
        </Grid>
      </Container>
      <Paper className={classes.paper} style={{ marginLeft: "24px", marginRight: "24px", marginBottom: "10px" }} >
                <form className={classes.root} noValidate autoComplete="off" style={{ marginBottom: "10px" }}>
                    <div>
                        <Grid container spacing={4} style={{ marginBottom: "10px" }} >
                            <Grid container item md={12} style={{ paddingLeft: "16px" }}>
                            <Grid container item xs={12} >
                         <Grid item xs={11} ></Grid>
                            {filter ? 
                                <Grid item xs={1} style={{ textAlign: "end" }}>
                                    <IconButton onClick={() => openFilter(false)}>
                                    <Tooltip title="Filter zuklappen">
                                        <ArrowForward />
                                    </Tooltip>
                                    </IconButton> 
                                </Grid> 
                                    : 
                                <Grid item xs={1} style={{ textAlign: "end"}}>
                                    <IconButton onClick={() => openFilter(true)}>
                                    <Tooltip title="Filter aufklappen">
                                    <FilterList />
                                    </Tooltip>
                                </IconButton>
                                </Grid>
                                } 
                                </Grid>
                                <Grid item md={filter ? 8 : 12} >
                                    {loadingGrid ? <CircularProgress size="30px" style={{ marginTop: "100px", padding: "1px" }} /> :
                                            datenplausibilitaetList.length > 0
                                                ?   <Grid container item md={12} >
                                                        <DatenplausibilitaetGrid />
                                                    </Grid>
                                                : <React.Fragment>
                                                    <Grid item md={12} style={{ textAlign: 'left', marginRight: "20px", marginLeft: "50px", paddingTop: "100px" }}>
                                                        <div style={{ height: "30vh" }}>
                                                          <Typography >
                                                              { firstLoad ? "Bitte Filter definieren, um Datenplausibilität anzuzeigen. Bestätigen Sie den Filter über Anwenden." : "Keine Daten für den gewählten Zeitraum." }
                                                          </Typography>
                                                        </div>
                                                    </Grid>
                                                </React.Fragment>
                                            }
                                </Grid>
                                {filter ?
                                    <React.Fragment>
                                        <Grid item md={4} style={{ paddingLeft: "16px" }}>
                                            <Grid container md={12} style={{ paddingTop: "5px", paddingBottom: "24px", paddingRight: "24px", justifyContent: "end" }}>
                                                <Grid container md={1} style={{margin:"0px", width:"10px", maxWidth:"20px", padding:"0px"}} >
                                                    <Divider orientation="vertical" flexItem />
                                                </Grid>
                                                <Grid item container md={11}> 
                                                <Grid item md={12} style={{ textAlign: 'left', marginBottom: "20px"}}>
                                                      <Typography color="primary">Monat</Typography>
                                                      <MuiPickersUtilsProvider utils={DateFnsUtils} locale={de} >
                                                        <DatePicker
                                                          views={["year", "month"]}
                                                          className={datePicker}
                                                          label="Auswahl"
                                                          okLabel="OK"
                                                          cancelLabel="ABBRECHEN"
                                                          disableFuture={true}
                                                          invalidDateMessage={"Das ausgewählte Datum hat ein ungültiges Format."}
                                                          inputVariant="outlined"
                                                          minDate={new Date("2010-01-01")}
                                                          maxDate={endOfMonth(new Date())}
                                                          value={filterMonat}
                                                          onChange={(event) => {
                                                            const selectedDate = new Date(event + "");
                                                            const selectedMonthStart = subtractTimezoneOffset(startOfMonth(selectedDate));
                                                            const selectedMonthEnd = subtractTimezoneOffset(endOfMonth(selectedDate));

                                                            dispatch(setFilterMonat(selectedMonthStart));
                                                            dispatch(setFilterMonatEnde(selectedMonthEnd));
                                                           }}
                                                        />
                                                      </MuiPickersUtilsProvider>
                                                    </Grid>
                                                  <Grid item md={12} >   
                                                     <MessstellenFilter name={"datenplausibilitaet"}/>
                                                    <Grid item md={12} style={{ textAlign: "left", marginBottom: "20px" }}>                   
                                                      <Typography color="primary">Status</Typography>
                                                      <FormGroup row>
                                                        <FormControlLabel
                                                          style={{ marginRight: "30px" }}
                                                          control={
                                                            <Checkbox
                                                              checked={
                                                                filterStatus.find((e) => e == "offen") ? true : false
                                                              }
                                                              onChange={(e, nV) => {
                                                                nV
                                                                  ? dispatch(addStatus("offen"))
                                                                  : dispatch(removeStatus("offen"));
                                                              }}
                                                              name="offen"
                                                            />
                                                          }
                                                          label="Offen"
                                                        />
                                                        <FormControlLabel
                                                          style={{ marginRight: "30px" }}
                                                          control={
                                                            <Checkbox
                                                              checked={
                                                                filterStatus.find((e) => e == "verwendet") ? true : false
                                                              }
                                                              onChange={(e, nV) => {
                                                                nV
                                                                  ? dispatch(addStatus("verwendet"))
                                                                  : dispatch(removeStatus("verwendet"));
                                                              }}
                                                              name="verwendet"
                                                            />
                                                          }
                                                          label="Verwendet"
                                                        />
                                                        <FormControlLabel
                                                          style={{ marginRight: "30px" }}
                                                          control={
                                                            <Checkbox
                                                              checked={
                                                                filterStatus.find((e) => e == "verwerfen") ? true : false
                                                              }
                                                              onChange={(e, nV) => {
                                                                nV
                                                                  ? dispatch(addStatus("verwerfen"))
                                                                  : dispatch(removeStatus("verwerfen"));
                                                              }}
                                                              name="verwerfen"
                                                            />
                                                          }
                                                          label="Verworfen"
                                                        />
                                                      </FormGroup>
                                                  </Grid>
                                                        <Grid container md={12} style={{ marginTop: "30px" }} >
                                                            <Grid item container md={6} />
                                                            <Grid item container md={6} style={{ justifyContent: "end" }}>
                                                                
                                                                <Button
                                                                    style={{ width: "45%" }}
                                                                    variant="contained"
                                                                    onClick={() => {
                                                                      dispatch(setMessstelleWert());
                                                                      dispatch(getMesswertGeflaggt(messstelleWert, isUTC ? filterMonat : addTimezoneOffset(filterMonat), isUTC ? filterMonatEnde : addTimezoneOffset(filterMonatEnde), filterStatus))
                                                                    }}
                                                                    color="secondary"
                                                                    className={classes.showDuoButton}
                                                                    disabled={messstelleWert.length == 0 || filterStatus.length == 0}
                                                                    >
                                                                    Anwenden
                                                                </Button>

                                                            </Grid>
                                                        </Grid>
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </React.Fragment>
                                    : ""}
                            </Grid>
                        </Grid>
                    </div>
                </form>
            </Paper>
    </React.Fragment>
  );
}
